import { DataModel } from "@toolpad/core/Crud";
import {
  IHomeChargerSubscriptionSummaryDto,
  SubscriptionStatus,
} from "../generated/api-client";
import { enumToValueOptions, nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type HomeChargerSubscriptionDataModel = IHomeChargerSubscriptionSummaryDto &
  DataModel;

export default function HomeChargerSubscriptionsPage() {
  const columns: MagicCrudFields<IHomeChargerSubscriptionSummaryDto>[] = [
    {
      field: nameof<IHomeChargerSubscriptionSummaryDto>("shopSubscriptionId"),
      headerName: "shopSubscriptionId",
      type: "string",
      width: 220,
      isRequired: true,
      notInEditMode: true,
    },
    {
      field: nameof<IHomeChargerSubscriptionSummaryDto>("groupId"),
      headerName: "groupId",
      type: "string",
      extraType: "guid",
      width: 220,
      isRequired: true,
      notInEditMode: true,
    },
    {
      field: nameof<IHomeChargerSubscriptionSummaryDto>("groupCreateUserId"),
      headerName: "groupCreateUserId",
      type: "string",
      width: 180,
      notInEditMode: true,
      notInCreateMode: true,
    },
    {
      field: nameof<IHomeChargerSubscriptionSummaryDto>(
        "groupCreatedUserEmail"
      ),
      headerName: "groupCreatedUserEmail",
      type: "string",
      width: 200,
      notInEditMode: true,
      notInCreateMode: true,
    },
    {
      field: nameof<IHomeChargerSubscriptionSummaryDto>("status"),
      headerName: "subscriptionStatus",
      type: "singleSelect",
      valueOptions: enumToValueOptions(SubscriptionStatus),
      width: 140,
      isRequired: true,
    },
    {
      field: nameof<IHomeChargerSubscriptionSummaryDto>("expirationDate"),
      headerName: "subscriptionExpirationDate",
      type: "date",
      width: 220,
      isRequired: true,
    },
  ];

  return (
    <MagicCrud<HomeChargerSubscriptionDataModel>
      name="homeChargerSubscription"
      apiUrl="subscriptions/home-chargers"
      columns={columns}
      appUrl="/home-charger-subscriptions"
      getRowId={(row) => row.shopSubscriptionId ?? ""}
    />
  );
}
